var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_network",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 20,
    viewBox: "0 0 39 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 39,
    height: 15,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13577",
    "data-name": "Trac\\xE9 13577",
    d: "M0,0H39V20H0Z",
    fill: "#6639b7",
    opacity: 0.002
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_network-2",
    "data-name": "icon_network"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3774",
    "data-name": "Groupe 3774",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13577-2",
    "data-name": "Trac\\xE9 13577",
    d: "M19.141,0V7.664H22.8A1.831,1.831,0,0,1,24.625,9.5v3.667A1.831,1.831,0,0,1,22.8,15H11.828A1.831,1.831,0,0,1,10,13.166V9.5a1.831,1.831,0,0,1,1.828-1.834h3.656V0Z",
    transform: "translate(2.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686",
    "data-name": "Rectangle 1686",
    width: 9.75,
    height: 3.75,
    transform: "translate(29.25 9.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 9.75,
    height: 3.75,
    transform: "translate(0 9.54)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/icon_network.5fdb30e840a747d25d7f9726d99ae5bb.svg";
export { ForwardRef as ReactComponent };